export default {
  name: 'PageBlocker',

  mounted() {
    this.$store.commit('endLoad');
  }
};
